import React from 'react';

const TemplateConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/templateMessage-hsm',
			component: React.lazy(() => import('./Template'))
	}
	]
};

export default TemplateConfig;
